import {
  getListEventApi,
  createEventApi,
  updateEventApi,
  deleteEventApi,
  getChaptersApi,
  getCategoriesApi,
  getSubCategoriesApi,
} from '../../services/listEvent';
import { setListEvent, setIsLoading, setEventDictionaries } from '../actions/listEvent';
import { message } from 'antd';
import i18n from '../../i18n';
import { isEventAlreadyExistsError } from '../../utils/getNetwork';

export const getListEvent = () => async (dispatch) => {
  try {
    dispatch(setIsLoading(true));
    const response = await getListEventApi();
    dispatch(setListEvent(response.data));
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  } finally {
    dispatch(setIsLoading(false));
  }
};

export const createEvent = (data) => async (dispatch) => {
  try {
    await createEventApi(data);
    dispatch(getListEvent());
  } catch (error) {
    // Бек отдаёт код M.ERROR.06, когда мероприятие с такими параметрами уже есть
    message.error(
      isEventAlreadyExistsError(error)
        ? i18n.t('error.eventAlreadyExists')
        : i18n.t('error.createEvent')
    );
  }
};

export const updateEvent = (data) => async (dispatch) => {
  try {
    await updateEventApi(data);
    dispatch(getListEvent());
  } catch (error) {
    // Бек отдаёт код M.ERROR.06, когда мероприятие с такими параметрами уже есть
    message.error(
      isEventAlreadyExistsError(error)
        ? i18n.t('error.eventAlreadyExists')
        : i18n.t('error.updateEvent')
    );
  }
};

export const deleteEvent = (id) => async (dispatch) => {
  try {
    await deleteEventApi(id);
    dispatch(getListEvent());
  } catch (error) {
    message.error(i18n.t('error.deleteEvent'));
  }
};

export const loadEventDictionaries = () => async (dispatch) => {
  try {
    const [responseChapters, responseCategories, responseSubCategories] = await Promise.all([
      getChaptersApi(),
      getCategoriesApi(),
      getSubCategoriesApi(),
    ]);

    dispatch(
      setEventDictionaries({
        chapters: responseChapters.data,
        categories: responseCategories.data,
        subCategories: responseSubCategories.data,
      })
    );
  } catch (error) {
    message.error(i18n.t('error.loadingData'));
  }
};
